import axios from "axios";
import { type ProductCollectionModel } from "./models";
import {
    type PreselectedProductCollectionGroup,
    type ProductCollectionLeveledStructure,
} from "../types";

export async function getProductCollectionTree(
    productListId: number | undefined,
    preselectedCollectionIds: PreselectedProductCollectionGroup[] | null = null,
    currentStructure: ProductCollectionLeveledStructure | null = null,
    includeTest = false
) {
    return (
        await axios.get<{
            collections: ProductCollectionModel[];
            currentStructure: ProductCollectionLeveledStructure;
        }>("/ajax/GetProductCollectionTree", {
            params: {
                productListGuid: productListId,
                includeTests: includeTest,
                preselectedCollectionIds:
                    preselectedCollectionIds == null
                        ? ""
                        : JSON.stringify(preselectedCollectionIds),
                currentStructure:
                    currentStructure == null
                        ? ""
                        : JSON.stringify(currentStructure),
            },
        })
    ).data;
}
